module.exports = __webpack_public_path__ + "03c2fd0cd5eb9d8f8714e70bcf9401de.svg";